/**
 * SEO通用配置
 */

// 通用描述配置
const description = 'Innovative online Maths and English tuition that are specially designed and delivered to help students achieve better academic results in KS1, KS2, and SATs Tests.';
// 通用关键词配置
const keywords = 'Think Academy US, maths tuition, after school tuition, TAL, Xueersi, 100tal, grammar school, public school';

export default {
  common: {
    // Logo Alt描述
    logoDescription: 'Think Academy US',
  },
  home: {
    title: 'Think Academy - Accelerated Math Learning Program',
    description: 'Use Think Academy\'s accelerated math programs for grades K - 8 to set your child up for long-term success. Learn more!',
    keywords: 'Think Academy, math tutoring for kids, online math tutoring, TAL, kids math program, math tutor website',
  },
  coursesList: {
    title: 'Courses - Think Academy US',
    description: 'Use Think Academy\'s accelerated math programs for grades K - 8 to set your child up for long-term success. Learn more!',
    keywords,
  },
  coursesDetail: {
    title: '{title}Think Academy US',
    description,
    keywords,
  },
  bm: {
    title: 'Think Academy - Accelerated Math Learning Program',
    description: 'Our Basic Math K - 5th grade math courses are designed to take every child to the next level in math! See which course is the best fit for your child.',
    keywords: 'Think Academy, Basic Math, 5th grade math, math class, common core',
  },
  teacher: {
    title: 'Think Academy - Meet Our Team of Experienced Educators',
    description: 'All Think Academy teachers are experienced educators who are passionate about helping our students succeed.',
    keywords: 'kids math tutors near me, math tutor centers near me, online math tutoring, kids math program',
  },
  teachers: {
    title: 'Think Academy - Meet Our Team of Experienced Educators',
    description: 'All Think Academy teachers are experienced educators who are passionate about helping our students succeed.',
    keywords: 'kids math tutors near me, math tutor centers near me, online math tutoring, kids math program',
  },
  freeAssessment: {
    title: 'Think Academy - Get Started with Our Free Evaluation ',
    description: 'Start at Think Academy with a free 1-on-1 evaluation. Here our teachers will determine the right starting class for your child.',
    keywords: 'Free math evaluation, Think Academy, online math tutoring, math tutoring for kids, math tutor centers near me',
  },
  ourCourses: {
    title: 'Think Academy - Setting Your Child Up for Long Term Success',
    description: 'Think Academy\'s math courses helps strengthen children\'s critical thinking and logic skills, and prepares them for advanced-level math.',
    keywords: 'online math courses, math tutoring for kids, elementary math worksheets, teaching math online',
  },
  careers: {
    title: 'Careers - Think Academy US',
    description: '',
    keywords: '',
  },
  privacyPolicy: {
    title: 'Think Academy - Privacy Policy',
    description: 'Please read the following carefully to understand our views and practices regarding your personal data and how we will treat it. ',
    keywords: 'Think Academy, TAL, TAL Education group, privacy policy, math tutoring for kids',
  },
  termsOfUse: {
    title: 'Think Academy - Terms of Use',
    description: 'All rights to the trademarks, service marks, logos and trade names on this website belong to the Company or other right holders.',
    keywords: 'Think Academy, TAL Education Group, TAL, online math tutoring for kids',
  },
  refundPolicy: {
    title: 'Think Academy Refund Policy',
    description,
    keywords,
  },
  classChangeRules: {
    title: ' Think Academy - Reschedule/Transfer Rules',
    description,
    keywords,
  },
  internetSafetyTips: {
    title: 'Internet Safety Tips for Think Academy Student',
    description: 'All rights to the trademarks, service marks, logos and trade names on this website belong to the Company or other right holders.',
    keywords: 'Think Academy, TAL Education Group, TAL, online math tutoring for kids',
  },
}
